import type { ToothBasisSeriesName } from '@/shared/graphics/medicalImageRender/MedicalImageRender';

import { DEFAULT_TOOTH_SLICE_OPTIONS_BY_SERIES } from '../config';

const makeFullHeadMprSliceTileIDPrefix = ({
  seriesName,
  toothID,
}: {
  seriesName: ToothBasisSeriesName;
  toothID: string;
}) => `full-head-mpr-slice:${toothID}:${seriesName}:`;

export const makeFullHeadMprSliceTileID = ({
  offsetMm,
  seriesName,
  sliceStepMm,
  toothID,
}: {
  offsetMm: number;
  seriesName: ToothBasisSeriesName;
  toothID: string;
  sliceStepMm?: number;
}) => {
  const defaultStepMm =
    DEFAULT_TOOTH_SLICE_OPTIONS_BY_SERIES[seriesName].sliceStepMm;
  const resolvedStepMm = sliceStepMm ?? defaultStepMm;
  const offsetKey = offsetMm.toFixed(3);
  const stepKey =
    resolvedStepMm === defaultStepMm ? '' : `:step=${resolvedStepMm}`;

  return `${makeFullHeadMprSliceTileIDPrefix({ seriesName, toothID })}${
    offsetKey === '-0.000' ? '0.000' : offsetKey
  }${stepKey}`;
};

export const isFullHeadMprSliceTileIDOfSeries = ({
  seriesName,
  tileID,
  toothID,
}: {
  seriesName: ToothBasisSeriesName;
  tileID: string;
  toothID: string;
}) =>
  tileID.startsWith(makeFullHeadMprSliceTileIDPrefix({ seriesName, toothID }));
